// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yh-9s","fullView":"styles_fullView__2xG_k"};